import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  open(event) {
    if (event) { event.preventDefault() }
    var modal = new bootstrap.Modal("#partnersModal");
    modal.show()
    document.getElementById('partnersModal').getElementsByClassName('modal-content')[0].innerHTML = this.modalContent();
  }

  modalContent() {
    const partnerData = JSON.parse(this.element.dataset.partner)
    return `
      <div class="modal-header border-0 pb-0 position-relative">
        <button type="button" class="btn-close marketplace-modal-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-scrollable-content">
          <div class="text-center mb-4">
            ${partnerData.logo_url ? `<img src="${partnerData.logo_url}" alt="${partnerData.name}" class="marketplace-modal-logo"/>` : `<h2 class="mb-0">${partnerData.name}</h2>`}
          </div>
          <div class="marketplace-modal-description">
            ${partnerData.long_description}
          </div>
          <div class="d-flex justify-content-center">
            <a href="${partnerData.link}" target="_blank" class="btn btn-primary px-4 py-2 rounded-3">${partnerData.button_text}</a>
          </div>
        </div>
      </div>
    `
  }
}
